/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { ENVIRONMENT, Environment } from '../../services/inject-tokens/environment'
import { ConfigService } from '../../services/configuration/config.service'

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  private configService = inject(ConfigService)
  private environment = inject<Environment>(ENVIRONMENT)

  private static readonly PAGE_TITLE_DEFAULT_URL_P = 'https://my.porsche.com/core'
  private static readonly PAGE_TITLE_DEFAULT_URL_PP = 'https://my.porsche-preview.com/core'
  private readonly pageUrl: string // defaults to pp

  constructor() {
    const country = this.configService.getUrlCountry()
    const locale = this.configService.getUrlLocale()

    const basePageUrl = this.environment === 'p' ? PageTitleService.PAGE_TITLE_DEFAULT_URL_P : PageTitleService.PAGE_TITLE_DEFAULT_URL_PP

    this.pageUrl = `${basePageUrl}/${country}/${locale}/`
  }

  getPageUrl(): string {
    return this.pageUrl
  }
}
